import { useContext } from "react";
import { HeyatYoluContext } from "../../App";
import { Helmet } from "react-helmet";
import "./styles/About.css";

function About() {
const { paymentAmount, paymentEnabled } = useContext(HeyatYoluContext);

  return (
    <div className="ab-page">
      <Helmet>
        <title>HeyatYolu – Layihə Haqqında | Rəqəmsal Xatirə Platforması</title>
        <meta name="description" content="HeyatYolu - vəfat etmiş insanların xatirəsini yaşadan rəqəmsal platformadır." />
        <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=Noto+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>

      {/* ═══ HERO ═══ */}
      <header className="ab-hero">
        <div className="ab-hero__bg">
          <div className="ab-hero__particles">
            {[...Array(20)].map((_, i) => (
              <div key={i} className="ab-hero__particle" style={{
                '--x': `${Math.random() * 100}%`,
                '--y': `${Math.random() * 100}%`,
                '--d': `${8 + Math.random() * 12}s`,
                '--delay': `${Math.random() * 5}s`,
                '--size': `${2 + Math.random() * 4}px`
              }}></div>
            ))}
          </div>
        </div>

        <div className="ab-hero__content">
          <div className="ab-hero__symbol-wrap">
            <div className="ab-hero__glow"></div>
            <span className="ab-hero__symbol">🕊️</span>
          </div>

          <h1 className="ab-hero__title">
            <span className="ab-hero__title-small">Xatirələr</span>
            <span className="ab-hero__title-big">Əbədi Yaşayır</span>
          </h1>

          <p className="ab-hero__sub">
            Hər kəsin həyatı bir hekayədir. Biz o hekayələri unutmağa qoymayan,
            sevgini zamansız edən bir körpüyük.
          </p>

          <div className="ab-hero__scroll">
            <div className="ab-hero__scroll-line"></div>
          </div>
        </div>
      </header>

      {/* ═══ MANIFESTO ═══ */}
      <section className="ab-manifesto">
        <div className="ab-manifesto__inner">
          <div className="ab-manifesto__badge">MİSSİYAMIZ</div>
          <h2 className="ab-manifesto__title">
            İnsanı əbədi edən şey<br />
            <em>xatirələrdir</em>
          </h2>
          <div className="ab-manifesto__divider">
            <span></span><span></span><span></span>
          </div>
          <div className="ab-manifesto__cols">
            <p>
              <strong>HeyatYolu</strong> adi bir veb-sayt deyil — bu, sevgi ilə hörülmüş rəqəmsal abidədir.
              Hər bir insanın həyatı təkrarsızdır, hər bir xatirə əvəzsizdir. Biz bu təkrarsızlığı
              gələcək nəsillərə ötürmək missiyası ilə yaradıldıq.
            </p>
            <p>
              Burada göz yaşları ilə gülüşlər bir-birinə sarılır. Keçmişin ən gözəl anları
              rəqəmsal formada canlanır. Bir ananın laylası, bir atanın nəsihəti, bir dostun
              xatirəsi — hamısı burada əbədi qalır.
            </p>
          </div>
        </div>
      </section>

      {/* ═══ VALUES ═══ */}
      <section className="ab-values">
        <div className="ab-values__inner">
          <div className="ab-values__header">
            <span className="ab-values__label">DƏYƏRLƏRİMİZ</span>
            <h3 className="ab-values__title">Hər Xatirə Müqəddəsdir</h3>
          </div>

          <div className="ab-values__grid">
            <div className="ab-value" style={{ '--accent': '#e8c87a' }}>
              <div className="ab-value__num">01</div>
              <div className="ab-value__content">
                <div className="ab-value__icon">🌹</div>
                <h4>Sevgi Dolu Xatirələr</h4>
                <p>Hər bir həyat hekayəsi unikal bir əsərdir. Sevdiklərinizin adını, üzünü,
                  səsini — bütün bunları burada əbədiləşdirin. Çünki onlar yalnız
                  unutulduqda həqiqətən itirilir.</p>
              </div>
            </div>

            <div className="ab-value" style={{ '--accent': '#7aade8' }}>
              <div className="ab-value__num">02</div>
              <div className="ab-value__content">
                <div className="ab-value__icon">🤲</div>
                <h4>Həmdərdlik və Birlik</h4>
                <p>Kədər paylaşıldıqca yüngülləşir. Bu platformada minlərlə ailə bir-birinə
                  dayaq olur, birlikdə xatırlayır, birlikdə güc tapır. Burada
                  heç kim təkdeyil.</p>
              </div>
            </div>

            <div className="ab-value" style={{ '--accent': '#a87ae8' }}>
              <div className="ab-value__num">03</div>
              <div className="ab-value__content">
                <div className="ab-value__icon">✨</div>
                <h4>Ruhani Sakitlik</h4>
                <p>Bəzən yalnız xatırlamaq kifayətdir — ürəyə toxunan bir şəkil, bir tarix,
                  bir söz. Bu məkan sakitliyin, dərin düşüncənin və mənəvi rahatlığın
                  evidir.</p>
              </div>
            </div>

            <div className="ab-value" style={{ '--accent': '#7ae8b8' }}>
              <div className="ab-value__num">04</div>
              <div className="ab-value__content">
                <div className="ab-value__icon">🔒</div>
                <h4>Əbədi Qoruma</h4>
                <p>Paylaşdığınız xatirələr ən müasir texnologiyalarla qorunur. Heç bir məlumat
                  itmir, heç bir şəkil silinmir. Burada əbədiyyət sözü boş deyil — həqiqidir.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ MARTYRS ═══ */}
      <section className="ab-martyrs">
        <div className="ab-martyrs__flag-bg">
          <div className="ab-martyrs__stripe ab-martyrs__stripe--blue"></div>
          <div className="ab-martyrs__stripe ab-martyrs__stripe--red"></div>
          <div className="ab-martyrs__stripe ab-martyrs__stripe--green"></div>
        </div>
        <div className="ab-martyrs__overlay"></div>

        <div className="ab-martyrs__inner">
          <div className="ab-martyrs__header">
            <span className="ab-martyrs__label">ŞƏHİDLƏR</span>
            <h3 className="ab-martyrs__title">
              Şəhidlər Ölmür<br />
              <em>Vətən Bölünmür</em>
            </h3>
          </div>

          <p className="ab-martyrs__quote">
            "Vətən torpağına qanı ilə imza atan, canını fəda edən qəhrəmanlarımız —
            onların hər biri bir millət eşqinin əbədi timsalıdır."
          </p>

          <div className="ab-martyrs__features">
            <div className="ab-martyrs__feat">
              <div className="ab-martyrs__feat-icon">
                <span>🏅</span>
              </div>
              <div className="ab-martyrs__feat-body">
                <strong>Xüsusi Şəhid Statusu</strong>
                <p>Azərbaycan bayrağı, qırmızı dizayn, əbədi hörmət nişanı ilə</p>
              </div>
            </div>

            <div className="ab-martyrs__feat">
              <div className="ab-martyrs__feat-icon">
                <span>📜</span>
              </div>
              <div className="ab-martyrs__feat-body">
                <strong>Rəsmi Təsdiq Sistemi</strong>
                <p>Şəhidlik sənədi əsasında admin tərəfindən diqqətlə yoxlanılır</p>
              </div>
            </div>

            {paymentEnabled && (
              <div className="ab-martyrs__feat">
                <div className="ab-martyrs__feat-icon">
                  <span>🆓</span>
                </div>
                <div className="ab-martyrs__feat-body">
                  <strong>Tamamilə Ödənişsiz</strong>
                  <p>Şəhid ailələri heç vaxt ödəniş etmir — bu, bizim vətənə borcumuzdur</p>
                </div>
              </div>
            )}


          </div>
        </div>
      </section>

      {/* ═══ JOURNEY ═══ */}
      <section className="ab-journey">
        <div className="ab-journey__inner">
          <div className="ab-journey__header">
            <span className="ab-journey__label">ADDIMLAR</span>
            <h3 className="ab-journey__title">Xatirə Yolçuluğu</h3>
            <p className="ab-journey__sub">Sevdiklərinizin əbədi məkanını yaratmaq üçün sadəcə dörd addım</p>
          </div>

          <div className="ab-journey__timeline">
            <div className="ab-journey__line"></div>

            <div className="ab-journey__step">
              <div className="ab-journey__dot">1</div>
              <div className="ab-journey__card">
                <h4>Qeydiyyat</h4>
                <p>Hesabınızı yaradın və bu müqəddəs yolçuluğa ilk addımı atın</p>
              </div>
            </div>

            <div className="ab-journey__step">
              <div className="ab-journey__dot">2</div>
              <div className="ab-journey__card">
                <h4>Profil Yaratma</h4>
                <p>Sevdiyiniz insanın adını, şəklini, həyat hekayəsini sevgi ilə doldurun</p>
              </div>
            </div>

            <div className="ab-journey__step">
              <div className="ab-journey__dot">3</div>
              <div className="ab-journey__card">
                <h4>Xatirələri Paylaşma</h4>
                <p>Ailə üzvləri, dostlar — hamı birlikdə ən gözəl xatirələri yazsın</p>
              </div>
            </div>

            <div className="ab-journey__step">
              <div className="ab-journey__dot">4</div>
              <div className="ab-journey__card">
                <h4>Əbədi Yaşatma</h4>
                <p>Artıq onların xatirəsi heç vaxt itməyəcək — nəsillər boyunca yaşayacaq</p>
              </div>
            </div>
          </div>
        </div>
      </section>

   {/* ═══ PRICING ═══ */}
      {paymentEnabled ? (
        <section className="ab-pricing">
          <div className="ab-pricing__inner">
            <div className="ab-pricing__left">
              <span className="ab-pricing__label">QİYMƏT</span>
              <h3 className="ab-pricing__title">Xidmətin Dəyəri</h3>
              <p className="ab-pricing__desc">
                Sevdiklərinizin xatirəsini əbədi qorumaq üçün yalnız minimal texniki dəstək haqqı
                tələb olunur. Bu məbləğ serverlərin işləməsi, məlumatların təhlükəsizliyi və
                platformanın inkişafı üçün istifadə edilir.
              </p>
              <div className="ab-pricing__note">
                <span>🤝</span>
                <p>Şəhid ailələri üçün bu xidmət <strong>tamamilə ödənişsizdir</strong>. Bu, bizim onlara
                  olan minnətdarlıq və hörmətimizin kiçik ifadəsidir.</p>
              </div>
            </div>

            <div className="ab-pricing__right">
              <div className="ab-pricing__card">
                <div className="ab-pricing__tag">Birdəfəlik</div>
                <div className="ab-pricing__amount">
                  <span className="ab-pricing__number">{paymentAmount}</span>
                  <span className="ab-pricing__currency">AZN</span>
                </div>
                <span className="ab-pricing__per">hər profil üçün</span>
                <ul className="ab-pricing__includes">
                  <li>Əbədi profil səhifəsi</li>
                  <li>Limitsiz şəkil yükləmə</li>
                  <li>Başsağlığı mesajları</li>
                  <li>QR kod generasiya</li>
                  <li>İl dönümü bildirişləri</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <section className="ab-pricing">
          <div className="ab-pricing__inner">
            <div className="ab-pricing__left">
              <span className="ab-pricing__label">QİYMƏT</span>
              <h3 className="ab-pricing__title">Hazırda Tamamilə Ödənişsiz</h3>
              <p className="ab-pricing__desc">
                Hal-hazırda platformada xatirə profili yaratmaq hər kəs üçün ödənişsizdir.
                Yaradılan profillər keyfiyyət və doğruluq üçün admin tərəfindən yoxlanıldıqdan
                sonra yayımlanır.
              </p>
              <div className="ab-pricing__note">
                <span>🤝</span>
                <p>Sevdiklərinizin xatirəsini <strong>heç bir ödəniş etmədən</strong> əbədiləşdirin.</p>
              </div>
            </div>

            <div className="ab-pricing__right">
              <div className="ab-pricing__card">
                <div className="ab-pricing__tag">Hazırda</div>
                <div className="ab-pricing__amount">
                  <span className="ab-pricing__number">0</span>
                  <span className="ab-pricing__currency">AZN</span>
                </div>
                <span className="ab-pricing__per">hər profil üçün</span>
                <ul className="ab-pricing__includes">
                  <li>Əbədi profil səhifəsi</li>
                  <li>Limitsiz şəkil yükləmə</li>
                  <li>Başsağlığı mesajları</li>
                  <li>QR kod generasiya</li>
                  <li>İl dönümü bildirişləri</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* ═══ PROMISE ═══ */}
      <section className="ab-promise">
        <div className="ab-promise__inner">
          <div className="ab-promise__glow"></div>
          <span className="ab-promise__icon">🌟</span>
          <h3 className="ab-promise__title">Əbədi Vədimiz</h3>
          <div className="ab-promise__line"></div>
          <p className="ab-promise__text">
            Biz vəd edirik ki, bu platformaya etibar etdiyiniz hər bir xatirə, hər bir şəkil,
            hər bir söz — əbədi qorunacaq. Texnologiya dəyişə bilər, lakin sevgi dəyişməz.
            Gələcək nəsilləriniz burada keçmişin ən gözəl anlarını tapa biləcək.
          </p>
          <p className="ab-promise__italic">
            Çünki həqiqi itirilmə — unutulmaqdır.<br />
            Biz isə unutmağa icazə vermirik.
          </p>
        </div>
      </section>

      {/* ═══ QUOTE ═══ */}
      <footer className="ab-quote">
        <div className="ab-quote__inner">
          <div className="ab-quote__decoration">
            <span></span><span></span><span></span>
          </div>
          <blockquote className="ab-quote__text">
            Ölüm yalnız bədəni aparır.<br />
            Sevgi və xatirələr<br />
            <em>əbədi qalır.</em>
          </blockquote>
          <div className="ab-quote__source">— HeyatYolu</div>
        </div>
      </footer>
    </div>
  );
}

export default About;